var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _class2, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import mixTraits from "../../mixTraits";
import { BinStyleTraits, EnumStyleTraits, TableStyleMapSymbolTraits, TableStyleMapTraits } from "./StyleMapTraits";
export let OutlineSymbolTraits = (_dec = primitiveTrait({
  name: "Color",
  description: "Outline color.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Width",
  description: "Outline width (in pixels).",
  type: "number"
}), _dec3 = primitiveArrayTrait({
  name: "Dash Pattern",
  description: "An Array of numbers that specify distances to alternately draw a line and a gap (in pixels). If undefined, then line is solid. Note: only supported by line features (through GeoJSON Mixin)",
  type: "number"
}), _class = class OutlineSymbolTraits extends mixTraits(TableStyleMapSymbolTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "color", _descriptor, this);
    _initializerDefineProperty(this, "width", _descriptor2, this);
    _initializerDefineProperty(this, "dash", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "color", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "width", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dash", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export class EnumOutlineSymbolTraits extends mixTraits(OutlineSymbolTraits, EnumStyleTraits) {}
_defineProperty(EnumOutlineSymbolTraits, "isRemoval", EnumStyleTraits.isRemoval);
export class BinOutlineSymbolTraits extends mixTraits(OutlineSymbolTraits, BinStyleTraits) {}
_defineProperty(BinOutlineSymbolTraits, "isRemoval", BinStyleTraits.isRemoval);
let TableOutlineStyleTraits = (_dec4 = objectArrayTrait({
  name: "Enum Colors",
  description: "The outline style to use for enumerated values.",
  type: EnumOutlineSymbolTraits,
  idProperty: "value"
}), _dec5 = objectArrayTrait({
  name: "Enum Colors",
  description: "The outline style to use for bin values.",
  type: BinOutlineSymbolTraits,
  idProperty: "index"
}), _dec6 = objectTrait({
  name: "Enum Colors",
  description: "The default outline style.",
  type: OutlineSymbolTraits
}), _class2 = class TableOutlineStyleTraits extends mixTraits(TableStyleMapTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enum", _descriptor4, this);
    _initializerDefineProperty(this, "bin", _descriptor5, this);
    _initializerDefineProperty(this, "null", _descriptor6, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "enum", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "bin", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "null", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new OutlineSymbolTraits();
  }
}), _class2);
export { TableOutlineStyleTraits as default };